<template>
  <div class="">
    <div v-if="header" class="flex items-center border-b border-gray-400 py-2">
      <mdicon :name="icon" size="18" class="rounded-md bg-gray-300/50 p-1 mr-2 text-gray-500" aria-hidden="true"></mdicon>
      <h2 class="text-base font-semibold leading-7 text-gray-900">{{ title }}</h2>
    </div>
    <div class="">
      <div v-for="(item, idx) in propSet" :key="idx" class="my-2 py-1 flex justify-start border-b font-source">
        <dt class="text-gray-500">{{ item.name }}:</dt>
        <dd class="ml-2 text-gray-700 font-medium">
          {{ pathOr('', item.prop, src) }}
        </dd>
      </div>
    </div>
  </div>
</template>
<script setup>
  import { pathOr } from 'ramda';

  const props = defineProps({
    title: {
      type: String,
      default: 'Properties',
    },
    header: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      default: 'text',
    },
    src: {
      type: Object,
      default() {
        return {};
      },
    },
    propSet: {
      type: Array,
      default() {
        return [];
      },
    },
  });
</script>
